import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProductItem } from 'src/app/api/models';
import { ModalProdPickerComponent } from '../modal-prod-picker/modal-prod-picker.component';

export type ReplaceWithoutAssetChoice =
  | { mode: 'without' }
  | {
      mode: 'create';
      asset: { serial_number: string; related_product_id: number; office?: string };
    };

// Sostituzione da un ticket che non ha un asset collegato: si può creare al volo l'asset da
// sostituire (resta collegato al ticket) oppure procedere senza. Il chiamante mostra questa
// scelta solo a chi può creare asset.
@Component({
  selector: 'app-modal-replace-without-asset',
  templateUrl: './modal-replace-without-asset.component.html',
})
export class ModalReplaceWithoutAssetComponent {
  restrictToAgreementId?: number;
  mode = new FormControl<'create' | 'without'>('create', { nonNullable: true });
  product?: ProductItem;
  serial = new FormControl('', { nonNullable: true, validators: [Validators.required] });
  office = new FormControl('', { nonNullable: true });

  constructor(
    public ref: DynamicDialogRef,
    config: DynamicDialogConfig,
    private dialogService: DialogService
  ) {
    this.restrictToAgreementId = config.data?.restrictToAgreementId;
  }

  get canConfirm(): boolean {
    if (this.mode.value === 'without') return true;
    return !!this.product?.id && !!this.serial.value.trim();
  }

  pickProduct() {
    const picker = this.dialogService.open(ModalProdPickerComponent, {
      data: {
        question_title: 'Seleziona il prodotto da sostituire',
        chosenProducts: this.product ? [this.product] : [],
        restrict_to_agreement_id: this.restrictToAgreementId,
        pickerType: 'radio',
        showOnlySerializedProducts: true,
      },
      header: 'Seleziona il prodotto da sostituire',
      width: '900px',
      baseZIndex: 11000,
    });
    picker.onClose.subscribe((p?: { value: ProductItem }) => {
      if (p?.value) {
        this.product = p.value;
      }
    });
  }

  cancel() {
    this.ref.close();
  }

  confirm() {
    if (!this.canConfirm) return;
    const choice: ReplaceWithoutAssetChoice =
      this.mode.value === 'without'
        ? { mode: 'without' }
        : {
            mode: 'create',
            asset: {
              serial_number: this.serial.value.trim(),
              related_product_id: this.product!.id!,
              ...(this.office.value.trim() && { office: this.office.value.trim() }),
            },
          };
    this.ref.close(choice);
  }
}
